<!-- HEADER -->
<ng-container *transloco="let t; prefix: 'mayBeEligible'">
  <div class="header-wrapper">
    <page-header
      [title]="t('title')"
      [icon]="['fas', 'home']"
      hasClose="true"
      (pageClose)="onClose()"
      shadowOnScroll
    ></page-header>
    <page-description>
      <p [innerHTML]="t('description')"></p>
    </page-description>
  </div>

  <!-- CONTENT -->
  <div class="content-wrapper push-footer-down"></div>

  <!-- FOOTER -->
  <div class="footer-wrapper not-fixed shadow">
    <page-footer
      [primary]="{ label: t('doneBtn') }"
      (primaryClicked)="onClose()"
      [secondary]="{ label: t('cancelBtn'), arrow: 'left' }"
      (secondaryClicked)="onClose()"
    ></page-footer>
  </div>
</ng-container>
